import { useState } from "react";
import useSWR from "swr";
import RootLanding from '../../components/layouts/RootLanding'
import banner from '../../assets/banner/arsip-banner.png';
import { Button, Card, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, useDisclosure } from "@nextui-org/react";
import { EyeIcon } from "@heroicons/react/24/outline";
import { getFetcherPublic } from "../../services/api";
import ClientDataGrid from "../../components/elements/ClientDataGrid";
import { formattedDate } from "../../services/helpers";

export default function B3Database() {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const { data, isLoading } = useSWR(`/api/data-master/public/search-bahan-b3?returnAll=true`, getFetcherPublic);
  const detailItem = (item) => [
    { label: "Nomor Cas", value: item?.casNumber ?? '-' },
    { label: "Kode HS", value:item?.hsCode?.join(", ") ?? '-' },
    { label: "Nama Dagang", value: item?.namaDagang ?? '-' },
    { label: "Nama Iupac", value: item?.namaIupac ?? '-' },
    { label: "Nama Trivial", value: item?.namaTrivial ?? '-' },
    { label: "Rumus Molekul", value: item?.rumusMolekul ?? '-' },
    { label: "Rumus Struktur", value: item?.rumusStruktur ?? '-' },
    { label: "Berat Mr", value: item?.beratMr ?? '-' },
    { label: "Sifat Fisik", value: item?.sifatFisik ?? '-' },
    { label: "Titik Didih", value: item?.titikDidih ?? '-' },
    { label: "Titik Lebur", value: item?.titikLebur ?? '-' },
    { label: "Kelarutan", value: item?.kelarutan ?? '-' },
    { label: "Densitas", value: item?.densitas ?? '-' },
    { label: "Tekanan Uap", value: item?.tekananUap ?? '-' },
    { label: "Kegunaan", value: item?.kegunaan ?? '-' },
    { label: "Dampak Kesehatan", value: item?.dampakKesehatan ?? '-' },
    { label: "Penanganan Resiko", value: item?.penangananResiko ?? '-' },
    { label: "APD", value: item?.apd ?? '-' },
    { label: "Sifat Bahaya", value: item?.KlasifikasiBahanB3?.namaKlasifikasi ?? '-' },
    { label: "Status Penggunaan", value: item?.KategoriBahanB3?.namaKategori ?? '-' },
    { label: "Status Stockholm", value: item?.statusStockholm ?? '-' },
    { label: "Url", value: item?.url ?? '-' },
    { label: "Keterangan", value: item?.keterangan ?? '-' },
    { label: "Last Update", value: formattedDate(item?.updatedAt) ?? '-' },
  ]

  const columns = [
    { field: "casNumber", headerName: "Nomor Cas"},
    { field: "hsCode", headerName: "Kode Hs",
      valueGetter: (params) => params.row?.hsCode?.join(", ") ?? '-',
      renderCell: (params) => (
        <span>{params.row?.hsCode?.join(", ") ?? '-'}</span>
      ),
     },
    { field: "namaDagang", headerName: "Nama Dagang" },
    { field: "namaIupac", headerName: "Nama IUPAC" },
    { field: "namaTrivial", headerName: "Nama Trivial" },
    { field: "rumusMolekul", headerName: "Rumus Molekul" },
    {
      field: "statusPenggunaan",
      headerName: "Status Penggunaan",
      renderCell: (params) => (
        <span className={`text-${params.row?.KategoriBahanB3?.namaKategori === "Dilarang digunakan" ? "danger" : params.value === "Terbatas digunakan" ? "warning" : "success"}`}>
          {params?.row?.KategoriBahanB3?.namaKategori}
        </span>
      ),
    },
    {
      field: "statusStockholm",
      headerName: "Status Stockholm",
      renderCell: (params) => (
        <span style={{ color: params.value ? "blue" : "gray" }}>
          {params.value ? "Terdaftar" : "Tidak Terdaftar"}
        </span>
      ),
    },
    {
      field: "detail",
      headerName: "Detail",
      renderCell: (params) => <ModalDetailList list={detailItem(params.row)}/>,
    },
  ];

  return (
    <RootLanding>
      <div className="relative bg-gradient-to-r text-white overflow-hidden">
        <div className="absolute inset-0">
          <img src={banner} alt="Background Image" className="object-cover object-center w-full h-full" />
          <div className="absolute inset-0 bg-black opacity-50"></div>
        </div>
        
        <div className="relative z-10 text-center md:text-start px-5 md:px-10 lg:px-20 py-28">
          <h1 className="text-5xl font-bold leading-tight mb-4">DATABASE B3 DAN POPs</h1>
        </div>
      </div>
      <Card className="px-5 md:px-10 lg:px-20 py-20" radius="none">  
          <div className="flex gap-5 mb-5">
            <button
              style={{
                backgroundColor: "#0E66C4",
                color: "#fff",
                border: "none",
                padding: "6px 12px",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              Quick Search
            </button>
            <button
              style={{
                backgroundColor: "#0E66C4",
                color: "#fff",
                border: "none",
                padding: "6px 12px",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              Filter By
            </button>
          </div>
          <div className="h-[500px]">
            <ClientDataGrid
              rows={data?.data}
              rowCount={data?.total || 0}
              isLoading={isLoading}
              columns={columns}
              page={page}
              setPage={setPage}
              pageSize={pageSize}
              setPageSize={setPageSize}
            />
          </div>
      </Card>
    </RootLanding>
  );
}

function ModalDetailList({ list }) {
  const { isOpen, onOpen, onOpenChange } = useDisclosure();

  return (
    <>
      <Button onPress={onOpen} color="primary" size="sm" isIconOnly><EyeIcon className="size-4" /></Button>
      <Modal scrollBehavior="inside" size="5xl" isOpen={isOpen} onOpenChange={onOpenChange}>
        <ModalContent>
          {(onClose) => (
              <>
                <ModalHeader className="flex flex-col gap-1">Detail Data Bahan B3</ModalHeader>
                <ModalBody className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                  {list.map((item, index) => (
                    <div key={index} className='flex flex-col'>
                      <span className='text-xs text-ink-400 uppercase'>{item.label}</span>
                      <span className='text-sm font-medium'>{item.value}</span>
                    </div>
                  ))}
                </ModalBody>
                <ModalFooter>
                  <Button color="danger" variant="light" onPress={onClose}>
                    Tutup
                  </Button>
                </ModalFooter>
              </>
          )}
        </ModalContent>
      </Modal>
    
    </>
  )
}
